import { z } from 'zod';
import { getDefaults, MAX_INPUT_TEXT_LENGTH, Validation } from '@mews/framework';
import prefix from '../app/prefix';
import { CounterFormField, CounterUseFor } from './components/CounterForm/formMapping';

export const CREATE_COUNTER_DIALOG = 'create-counter';
export const EDIT_COUNTER_DIALOG = 'edit-counter';

export const CREATE_COUNTER = prefix('CREATE_COUNTER');
export const UPDATE_COUNTER = prefix('UPDATE_COUNTER');
export const DELETE_COUNTER = prefix('DELETE_COUNTER');
export const RESET_COUNTER = prefix('RESET_COUNTER');

export const creditNoteCounterValidationSchema = z.object({
    [CounterFormField.Title]: Validation.String.Required.max(MAX_INPUT_TEXT_LENGTH).default(''),
    [CounterFormField.Name]: Validation.String.Required.max(MAX_INPUT_TEXT_LENGTH).default(''),
    [CounterFormField.StartValue]: Validation.Number.MaxPositiveInteger.default(1),
    [CounterFormField.NumberOfDigits]: Validation.Number.MaxPositiveInteger.default(1),
    [CounterFormField.Prefix]: Validation.String.Empty.nullish().default(''),
    [CounterFormField.DisplayCID]: z.boolean().default(false),
    [CounterFormField.BillTypeCode]: Validation.String.Empty.nullish().default(''),
    [CounterFormField.IsDefault]: z.boolean().default(false),
    [CounterFormField.UseFor]: z.array(z.nativeEnum(CounterUseFor)).min(1).default([]),
    [CounterFormField.Created]: z.string().optional(),
    [CounterFormField.Updated]: z.string().optional(),
    [CounterFormField.CounterId]: z.string().optional(),
});

export const creditNoteCounterDefaultValues = getDefaults(creditNoteCounterValidationSchema) as CreditNoteFormValues;
export type CreditNoteFormValues = z.infer<typeof creditNoteCounterValidationSchema>;
